<!--SESSIONS BLOCK-->
<h4 class="margin-bottom-small margin-top-small">{{ title }}</h4>
<div [ngClass]="course?.instructionType | layoutColumn : 'tile-layout'">
  <!-- iterate over each session, slicing for pagination -->
  <ng-container
    *ngFor="
      let session of sessions | slice : startPage : paginationLimit;
      let i = index;
      trackBy: trackByCourseSessionsId
    ">
    <!-- Enroll if seats remain, otherwise Sold Out -->
    <app-card
      *ngIf="
        getIntegerValue(session.countEnrolled) < getIntegerValue(session.maxEnroll);
        else soldOutTpl
      "
      [cardType]="cardTypeSlugs.UPCOMING_SESSION"
      [showTooltip]="false"
      [customHeaderPanel]="'upcoming-session-panel'"
      [customHeaderCss]="'upcoming-session-header'"
      [customCardHeightCss]="'card-min-height'"
      [title]="session.name"
      [sessionDescription]="session"
      route="{{ 'subscription/' + course.subscriptionSlugName }}"
      (sendClick)="
        sendGoogleAnalytics('Course Detail', 'click', session.name);
        openEnrollSessionModal($event, course.id, session.idSession)
      "
      (secondarySendClick)="openUnenrollSessionModal($event, course.id, session)"
      [showErrorMessage]="true"
      [errorMessage]="
        sessionEnrollErrorMessage?.errorMessage
          ? sessionEnrollErrorMessage?.idSession === session.idSession
            ? sessionEnrollErrorMessage?.errorMessage
            : ''
          : session.sessionEnrollErrorMessage
      "
      [routeType]="
        course?.instructionType
          | cardTypeRouteType
            : currentUser
            : course.subscriptionId
            : course.relatedSubscriptionIds
            : course.id
            : course?.isFreeCourse
            : session.idSession
            : getIntegerValue(session.countEnrolled)
            : getIntegerValue(session.maxEnroll)
            : session.canEnroll
      "
      [buttonRoute]="
        course?.instructionType
          | sessionEnrollmentRoute
            : currentUser
            : course.subscriptionId
            : course.relatedSubscriptionIds
            : course.id
            : course.slugName
            : course?.subscriptionSlugName
            : course.type
            : session.idSession
            : getIntegerValue(session.countEnrolled)
            : getIntegerValue(session.maxEnroll)
      "
      [actionLabel]="
        course?.instructionType
          | sessionEnrollmentCallToActions
            : currentUser
            : course.subscriptionId
            : course.relatedSubscriptionIds
            : course.id
            : session.idSession
            : getIntegerValue(session.countEnrolled)
            : getIntegerValue(session.maxEnroll)
      "
      [secondaryActionLabel]="cardTypeCallToActions.UNENROLL"
      [showSecondaryButton]="true">
    </app-card>

    <!-- sold-out template -->
    <ng-template #soldOutTpl>
      <app-card
        [cardType]="cardTypeSlugs.UPCOMING_SESSION"
        [showTooltip]="false"
        [customHeaderPanel]="'upcoming-session-panel'"
        [customHeaderCss]="'upcoming-session-header'"
        [customCardHeightCss]="'card-min-height'"
        [title]="session.name"
        [sessionDescription]="session"
        [routeType]="'internal'"
        [buttonRoute]="null"
        [actionLabel]="'Sold Out'"
        [disabled]="true"
        [showSecondaryButton]="false">
      </app-card>
    </ng-template>
  </ng-container>
</div>
<!--SHOW MORE BUTTON-->
<ng-container *ngIf="paginationLimit < sessions?.length">
  <div class="text-align-center margin-top-large">
    <button class="btn btn-inverse" (click)="showMoreItems()">Show More</button>
  </div>
</ng-container>
<!--END SHOW MORE BUTTON-->
<!--END SESSIONS BLOCK-->

<!--ENROLLED SESSION MESSAGE INSTRUCTIONS-->
<app-modal-dialog
  [containerID]="'enrolledContent'"
  [modalMaxWidth]="'modal-max-width-medium'"
  (sendClick)="onClick($event)">
  <div #modalContainer>
    <app-instructions-list
      [title]="'You are enrolled!'"
      [shortTitle]="'Next steps'"
      [showInstructions]="'enrolledContent'"
      [instructionContentClass]="'instructions-enrolled-header'"
      [toggleExpandCollapse]="true"
      [steps]="getInstructionsByName(instructionSteps.INSTRUCTOR_LED_ENROLLED_SESSION_STEPS)">
    </app-instructions-list>
  </div>
</app-modal-dialog>
<!--END ENROLLED SESSION MESSAGE INSTRUCTIONS-->

<!--UNENROLLED SESSION MESSAGE INSTRUCTIONS-->
<app-modal-dialog
  #modalDialog
  [containerID]="'unEnrolledContent'"
  [modalMaxWidth]="'modal-max-width-medium'"
  (sendClick)="onClick($event)">
  <div #modalContainer>
    <app-confirm-dialog
      [title]="'Unenrollment'"
      [message]="'Are you sure you want to unenroll from <strong>' + sessionName + '</strong> ?'"
      (confirmClicked)="unEnrollSession()">
    </app-confirm-dialog>
  </div>
</app-modal-dialog>
<!--END UNENROLLED SESSION MESSAGE INSTRUCTIONS-->
